import { Observable, throwError, from } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerMessage } from '../_models/server.message';
import { environment } from 'environments/environment';
import { AuthenticationService, StorageService } from '../_services';
import { decrypt } from '../_services/security.service';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  //Prod
  // private urlDocManager = environment.DOC_MANAGER_LAMBDA_PROD
  // private urlServiceSyndifi = environment.URL_SYNDIFY_PROD;

  //Staging
  private urlDocManager = environment.DOC_MANAGER_LAMBDA_PROD;
  private urlServiceSyndifi = environment.URL_SYNDIFY_PROD;

  private mailerApiKey = environment.MAILER_API_KEY;
  private environment = environment.environment;

  //Email    
  // private urlEmail = environment.EMAIL_SENDER_LAMBDA_CANADA;
  private urlEmail = environment.EMAIL_SENDER_LAMDBA;

  //CP
  private urlCP = environment.CP_SYNDIFI_PROD;

  private subdomain: string = location.host.split('.')[0];

  //Encrypt mode
  private encryptData = environment.encryptData;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private authenticationService: AuthenticationService,) {
  }

  async offerDeal(req): Promise<any> {
    let reqObj = {
      mode: "offer-deal",
      // sellerId: req.sellerId,
      buyerId: req.buyerId,
      dealId: req.dealId,
      approvedStructure: req.approvedStructure,
      status: req.status,
      approvedBuyRate: req.approvedBuyRate,
      leaseType: req.leaseType,
      term: req.term,
      appovedAmount: req.appovedAmount,
      monthlyPayment: req.monthlyPayment,
      securityDeposit: req.securityDeposit,
      downPayment: req.downPayment,
      advancedPayments: req.advancedPayments,
      residual: req.residual,
      notes: req.notes,
      approvalExpirationDate: req.approvalExpirationDate,
      submittedDate: req.submittedDate,
      currentDate: req.currentDate,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

    async setHideModal(req):Promise<any> {
    let reqObj = {
      mode: "set-user-hidden-modal",
      modalId: req.modalId,
      // sellerId: req.sellerId,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }
  async getCreditQuality():Promise<any> {
    let reqObj = {
      mode: "get-credit-quality",
      // sellerId: req.sellerId,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }
  async getHideModal(req):Promise<any> {
    let reqObj = {
      mode: "get-user-hidden-modal",
      // sellerId: req.sellerId,
      modalId: req.modalId,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async offerDealPool(req): Promise<any> {
    let reqObj = {
      mode: "offer-deal-pool",
      sellerId: req.sellerId,
      buyerId: req.buyerId,
      dealId: req.dealId,
      Status: req.Status,
      SharedDate: req.SharedDate,
      ApprovedDate: req.ApprovedDate,
      DealsApproved: req.DealsApproved,
      ApprovedDiscountRate: req.ApprovedDiscountRate,
      TotalEquipmentCost: req.TotalEquipmentCost,
      PVPurchasePrice: req.PVPurchasePrice,
      ProjectedFeeIncome: req.ProjectedFeeIncome,
      COBDate: req.COBDate,
      TargetPurchaseDate: req.TargetPurchaseDate,
      ApprovalExpirationDate: req.ApprovalExpirationDate,
      Comment: req.Comment,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async declineDeal(req): Promise<any> {
    let reqObj = {
      mode: "decline-deal",
      // sellerId: req.sellerId,
      buyerId: req.buyerId,
      dealId: req.dealId,
      status: req.status,
      submittedDate: req.submittedDate,
      currentDate: req.currentDate,
      notes: req.notes,
      reason: req.reason,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async declineDealPool(req): Promise<any> {
    let reqObj = {
      mode: "decline-deal-pool",
      sellerId: req.sellerId,
      buyerId: req.buyerId,
      dealId: req.dealId,
      Status: req.Status,
      SharedDate: req.SharedDate,
      DeclinedDate: req.DeclinedDate,
      Comment: req.Comment,
      Reason: req.Reason,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async editUser(req): Promise<any> {
    let reqObj =

    {
      "EditCompanyUser": {
        1: {
          "FirstName": req.FirstName,
          "LastName ": "Registered ",
          "UserID": req.UserId,
          "PercentageOwnership ": null,
          "MobileNumber ": req.officePhone,
          "Extension ": 1,
          "UserTypeID ": 9,
          "oldUserTypeID ": 9
        },
        "LoginSessionKey ": req.LoginSessionKey,
        "CompanyID ": req.CompanyId
      }
    }
    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlCP + 'EditCompanyUser',
          reqObj,
          headers)
          .subscribe({
            next: resp => { resolve(resp['message']) }, error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async blockUser(req): Promise<any> {
    let reqObj =

    {
      "UpdateUserStatus  ": {
        "UserID  ": req.userId,
        "LoginSessionKey  ": "8f53076bbc6dd26f0b2b62c19a3ce744 ",
        "StatusID  ": 3,
        "currentStatus  ": 2
      }
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlCP + "UpdateUserStatus",
          reqObj,
          headers)
          .subscribe({
            next: resp => { resolve(resp['message']) }, error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getListUserAdmin(req): Promise<any> {
    let reqObj =

    {
      mode: "list-users",
      adminId: req.adminId,
      adminEmail: req.adminEmail,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async sendInviteNotification(req): Promise<any> {
    let reqObj =

    {
      mode: "notify-pool-invitation",
      dealPool: req,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false,
      
    }

    

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async sendChatNotification(req): Promise<any> {
    let reqObj =
    {
      mode: "notify-chat-message",
      recipientFullName: req.recipientFullName,
      recipientEmail: req.recipientEmail,
      messageSender: req.messageSender,
      dealName: req.dealName,
      messageContent: req.messageContent,
      chatUrl: req.chatUrl,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async notifySignatureRequest(req): Promise<any> {
    let reqObj =
    {
      mode: "notify-signature-request",
      documentName: req.documentName,
      dealName: req.dealName,
      recipientFullName: req.recipientFullName,
      userId: req.userId,
      recipientEmail: req.recipientEmail,
      logginAccessKey: req.logginAccessKey,
      chatUrl: req.chatUrl,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


   async markNotificationRead(notificationUID: string): Promise<any> {
    let reqObj = {
      mode: "mark-notification-read",
      notificationUID: notificationUID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async reassignDeals(req): Promise<any> {
    let reqObj =

    {
      mode: "reassign-seller",
      oldUser: req.oldUser,
      newUser: req.newUser,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async grantAccessFolder(req): Promise<any> {
    let reqObj =
    {
      mode: "save-file-and-folder-access",
      folderId: req.folderId,
      userIdAccess: req.userId,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getDealGroupAssociateBuyers(req): Promise<any> {
    let reqObj = {
      mode: "get-deal-group-associate-buyers",
      dealGroupId: req.dealGroupId,
      primaryBuyer: req.primaryBuyer,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }

  }


  async getAllBuyersDeal(req): Promise<any> {

    let reqObj =
    {
      mode: "get-deal-invited-buyers",
      dealId: req.dealId,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async getDealAssociateBuyers(req): Promise<any> {

    let reqObj =
    {
      mode: "get-deal-associate-buyers",
      primaryBuyerEmail: req.primaryBuyerEmail,
      requestorEmail: req.requestorEmail,
      dealId: req.dealId,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getDealPrimaryBuyers(req): Promise<any> {

    let reqObj =
    {
      mode: "get-deal-primary-buyers",
      dealId: req.dealId,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async getAllDealPoolBuyers(req): Promise<any> {

    let reqObj =
    {
      mode: "get-all-deal-pool-buyers",
      dealPoolId: req.dealPoolId,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async getDealPoolPrimaryBuyers(req): Promise<any> {

    let reqObj =
    {
      mode: "get-deal-pool-primary-buyers",
      dealPoolId: req.dealPoolId,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async revokeAccessFolder(req): Promise<any> {

    let reqObj =
    {
      mode: "delete-file-and-folder-access",
      folderId: req.folderId,
      userIdRevoke: req.userId,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async fileFolderAccess(req): Promise<any> {

    let reqObj =
    {
      mode: "file-and-folder-access",
      folderId: req.folderId,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async saveDeal(req): Promise<any> {

    try {
      let finalUrl = this.urlServiceSyndifi + req.mode;

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            // "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(finalUrl,
          req.obj,
          headers)
          .subscribe({
            next: resp => { resolve(resp) }, error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async saveBussiness(req): Promise<any> {

    try {
      let finalUrl = this.urlServiceSyndifi + req.mode;

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(finalUrl,
          req.obj,
          headers)
          .subscribe({
            next: resp => { resolve(resp) }, error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async changeDealStatus(req): Promise<any> {

    try {
      let finalUrl = this.urlServiceSyndifi + req.mode;

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(finalUrl,
          req.obj,
          headers)
          .subscribe({
            next: resp => { resolve(resp) }, error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async sendMail(req): Promise<any> {

    const reqObj = {
    ...req,
    environment: this.environment,
    logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
    userId: this.authenticationService.currentUserValue.UserDetails.UserID,
    emulate: this.subdomain == 'cp' ? true : false,
    
  }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
            "x-api-key": this.mailerApiKey,
          })
        };

        this.http.post(this.urlEmail,
          reqObj,
          headers)
          .subscribe({
            next: resp => { resolve(resp['message']) }, error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async sendMailV2(req): Promise<any> {

    let reqObj = {
      to: req.to,
      template: req.template,
      content: req.content,
      custom: req.custom,
      type: req.type,
      environment: this.environment,
      subject: req?.subject,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    };

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            // "kintoken": localStorage.getItem('docManagerToken')
            "kintoken": localStorage.getItem('docManagerToken'),
            "x-api-key": this.mailerApiKey,
          })
        };

        this.http.post(this.urlEmail,
          reqObj,
          headers)
          .subscribe({
            next: resp => { resolve(resp['message']) }, error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async sendMailV2Multiples(req): Promise<any> {

  const reqObj = {
    ...req,
    environment: this.environment,
    logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
    userId: this.authenticationService.currentUserValue.UserDetails.UserID,
    emulate: this.subdomain == 'cp' ? true : false
  }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
            "x-api-key": this.mailerApiKey,
          })
        };

        this.http.post(this.urlEmail,
          reqObj,
          headers)
          .subscribe({
            next: resp => { resolve(resp['message']) }, error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


    async recordDocumentView(req): Promise<any> {
    let reqObj =
    {
      mode: "record-doc-view",
      ...req,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

      async saveLog(req): Promise<any> {

    let reqObj =
    {
      mode: "save-log",
      ...req,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }


    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getDocDowloadUrl(req): Promise<any> {
    let reqObj =
    {
      mode: "get-download-url",
      filePath: req.filePath,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getOffersTemplates(req): Promise<any> {
    let reqObj =
    {
      mode: "get-offer-templates",
      dealId: req.dealId,
      filePath: req.filePath,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async getDocOverwriteUrl(req): Promise<any> {
    let reqObj =
    {
      mode: "get-overwrite-url",
      filePath: req.filePath,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async getDealPoolData(req): Promise<any> {

    let reqObj =
    {
      mode: "get-info-dealpool",
      userIdPool: req.userId,
      dealPoolId: req.dealPoolId,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getListRequestNewPool(req): Promise<any> {
    let reqObj =

    {
      mode: "list-pool-request",
      SellerID: req.SellerID,
      DealPoolID: req.DealPoolID,
      BuyerID: req.BuyerID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getListContainRequestPool(req): Promise<any> {
    let reqObj =

    {
      mode: "list-contain-pool-request",
      PoolDealsRequestID: req.PoolDealsRequestID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async updateStatusRequestPool(req): Promise<any> {
    let reqObj =

    {
      mode: "update-pool-request",
      PoolDealsRequestID: req.PoolDealsRequestID,
      Status: req.Status,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async createRequestPool(req): Promise<any> {
    let reqObj =

    {
      mode: "save-pools-request",
      RequesterID: req.RequesterID,
      SellerID: req.SellerID,
      DealPoolID: req.DealPoolID,
      PoolDealsID: req.PoolDealsID,
      DealPoolStatusID: req.DealPoolStatusID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async updatePoolDeals(req): Promise<any> {
    let reqObj =

    {
      mode: "update-pool-deals",
      DealPoolChanges: req.DealPoolChanges,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async deleteUserConnection(req): Promise<any> {
    let reqObj =

    {
      mode: "delete-connections-user",
      buyerID: req.buyerID,
      connectionID: req.connectionID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getDealsNotAccepted(req): Promise<any> {
    let reqObj =

    {
      mode: "get-deal-not-accepted",
      dealpoolIds: req.dealpoolIds,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              result['internalCode'] = 500;
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getStates(): Promise<any> {

    let reqObj =
    {
      mode: "get-states",
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async AssignLeaseNumber(req): Promise<any> {
    let reqObj = {
      mode: "assign-lease-number",
      mediaId: req.mediaId,
      leaseNo: req.leaseNo,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getBuyersConnectifi(): Promise<any> {

    let reqObj =

    {
      mode: "get-buyers-connectifi",
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey
    }

    try {
      return new Promise((resolve) => {

        let tempHeaders = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'kintoken': localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          tempHeaders)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

    async getBuyingCompanies(): Promise<any> {
    let reqObj = {
      mode: "get-buying-companies-connectifi",
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        let tempHeaders = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'kintoken': localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          tempHeaders)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


    async getBuyersConnectifiDealProfile(): Promise<any> {

    let reqObj = {
      mode: "get-buyers-connectifi-deal-profile",
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        let tempHeaders = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'kintoken': localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          tempHeaders)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

    async connectCompany(req): Promise<any> {
    let reqObj =
    {
      mode: "connect-buying-company",
      ...req,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async createRequestConnectifi(req): Promise<any> {
    let reqObj =

    {
      mode: "connectifi-request",
      buyerId: req.buyerId,
      sellerId: req.sellerId,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async updateRequestConnectifi(req): Promise<any> {
    let reqObj =

    {
      mode: "connectifi-request-update",
      connectifiRequestID: req.connectifiRequestID,
      statusRequest: req.statusRequest,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getPendingConnectifi(req): Promise<any> {

    try {
      let reqObj =
      {
        mode: "get-pending-connectifi",
        typeUser: req.typeUser,
        userId: req.userId,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }
  
  async saveContact(req): Promise<any> {
    let reqObj = {
      mode: "add-contact",
      ...req,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              console.log("errorError", error)
              console.log("result", JSON.parse(decrypt(error)))
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error));
                console.log(result)
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'], errorMessage: result.message });
            }
          });
      })
    } catch (err) {
      console.error("errCatch", err);
    }
  }

  async searchContactByEmail(email: string): Promise<any> {
    let reqObj = {
      mode: "search-contact-by-email",
      email: email,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'], errorMessage: result.message });
            }
          });
      })
    } catch (err) {
      console.error("errCatch", err);
    }
  }

  async editContact(req): Promise<any> {
    let reqObj = {
      mode: "edit-contact",
      ...req,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'], errorMessage:  result.message });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async checkUserRegistered(req): Promise<any> {
    let reqObj =
    {
      mode: "check-user-registered",
      email: req.email,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getDealInvites(req): Promise<any> {
    let reqObj =
    {
      mode: "list-invite-deals",
      dealId: req.dealId,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async getNotesPool(req): Promise<any> {
    let reqObj = {
      mode: "get-notes-pool",
      moduleEntityID: req.moduleEntityID,
      moduleName: req.moduleName,
      typeUser: req?.typeUser,
      email: req?.email,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async savePoolIDNote(req): Promise<any> {
    let reqObj = {
      mode: "save-poolid-in-notespool",
      PoolNoteID: req.poolNoteID,
      PoolDealID: req.poolDealID,
      PoolName: req.poolName,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async requestMoreInformationPool(req): Promise<any> {
    let reqObj = {
      mode: "update-request-information-pool",
      PoolDealID: req.poolDealID,
      status: req.status,
      description: req.description,
      sellerID: req.sellerID,
      buyerID: req.buyerID,
      whoSent: req.whoSent,
      typeDeal: req.typeDeal,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getIndividualOffers(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-individual-offers2024",
        PoolDealID: req.dealId,
        BuyerID: req?.buyerId,
        SellerID: req?.sellerId,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (err) {
      console.error(err);
    }

  }

  async loginDocManager(req): Promise<any> {

    try {
      let reqObj = {
        mode: "login",
        userId: req.userId,
        loginSessionKey: req.loginSessionKey
      }

      return new Promise((resolve) => {

        // Headers
        const headersLogin = { headers: new HttpHeaders({ 'Content-Type': 'application/json', }) };


        this.http.post(this.urlDocManager, reqObj, headersLogin).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = decrypt(resp['message']);
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async loginDocManagerAdmin(req): Promise<any> {

    try {
      let reqObj = {
        mode: "login",
        email: req.email,
        admin: true,
      }

      return new Promise((resolve) => {

        // Headers
        const headersLogin = { headers: new HttpHeaders({ 'Content-Type': 'application/json', }) };


        this.http.post(this.urlDocManager, reqObj, headersLogin).subscribe({
          next: (resp: any) => {
            let result;

            if (this.encryptData) {
              const tempResult: any = decrypt(resp['message']);
              result = typeof tempResult !== 'object' ? JSON.parse(tempResult) : tempResult;
            } else {
              result = resp;
            }

            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getIndivualDeals(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-individual-deals",
        userId: req.userId,
        typeUser: req.typeUser,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async removePoolOfBuyer(req): Promise<any> {

    try {
      let reqObj = {
        mode: "delete-user-from-pools",
        BuyerID: req.buyerID,
        PoolDealID: req.poolDealID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async editDealPool(req): Promise<any> {

    try {
      let reqObj = {
        mode: "edit-deal-pool",
        userId: req.userId,
        groupDealInfo: req.groupDealInfo,
        headerDealInfo: req.headerDealInfo,
        GroupsDealID: req.GroupsDealID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }



  async editDealGroup(req): Promise<any> {

    try {
      let reqObj = {
        mode: "edit-deal-group",
        userId: req.userId,
        groupDealInfo: req.groupDealInfo,
        headerDealInfo: req.headerDealInfo,
        GroupsDealID: req.GroupsDealID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async addDealGroup(req): Promise<any> {

    try {
      let reqObj = {
        mode: "add-deal-group",
        userId: req.userId,
        groupDealInfo: req.groupDealInfo,
        headerDealInfo: req.headerDealInfo,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getGroupsDeals(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-groups-deals",
        userId: req.userId,
        isBuyer: req.isBuyer,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getDealsGroup(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-deals-group",
        groupsDealID: req.groupsDealID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        typeUser: req.typeUser,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }


  

  async addInviteGroupDeals(req): Promise<any> {

    try {
      let reqObj = {
        mode: "add-invite-group-deals",
        groupDealId: req.groupDealId,
        buyerId: req?.buyerId,
        userId: req.userId,
        emailBuyer: req.emailBuyer,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async listInviteGroupDeals(req): Promise<any> {

    try {
      let reqObj = {
        mode: "list-invite-group-deals",
        groupDealId: req.groupDealId,
        userId: req.userId,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async listAllInviteGroupDeals(req): Promise<any> {

    try {
      let reqObj = {
        mode: "list-all-invite-group-deals",
        groupDealId: req.groupDealId,
        userId: req.userId,
        userEmail: req.userEmail,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async matchMissingDeals(req): Promise<any> {

    try {
      let reqObj = {
        mode: "match-missing-deals",
        userId: req.userId,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async deleteInviteGroupDeals(req): Promise<any> {

    try {
      let reqObj = {
        mode: "delete-invite-group-deals",
        groupDealId: req.groupDealId,
        buyerId: req.buyerId,
        userId: req.userId,
        emailBuyer: req.emailBuyer,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async createOfferDealGroup(req): Promise<any> {

    try {
      let reqObj = {
        mode: "create-offer-deal-group",
        dealGroupID: req.dealGroupID,
        groupDealID: req.groupDealID,
        sellerID: req.sellerID,
        buyerID: req.buyerID,
        statusID: req.statusID,
        submittedDate: req.submittedDate,
        offerDate: req.offerDate,
        approvalExpirationDate: req.approvalExpirationDate,
        offerBuyRate: req.offerBuyRate,
        offerStructure: req.offerStructure,
        notes: req.notes,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async listOfferDealGroup(req): Promise<any> {

    try {
      let reqObj = {
        mode: "list-offer-deal-group",
        dealGroupID: req.dealGroupID,
        buyerID: req.buyerID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  // update-status-offer-deal-group
  async updateStatusOfferDealGroup(req): Promise<any> {

    try {
      let reqObj = {
        mode: "update-status-offer-deal-group",
        dealsGroupOfferID: req.dealsGroupOfferID,
        statusID: req.statusID,
        reason: req?.reason,
        notes: req?.notes,
        submittedDate: req?.submittedDate,
        declinedDate: req?.declinedDate,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async createNoteGroupDeal(req): Promise<any> {

    try {

      let reqObj = {
        mode: "create-note-groupdeal",
        title: req.title,
        remarks: req.remarks,
        ownerID: req.ownerID,
        dealsGroupID: req.dealsGroupID,
        dealGroupName: req.dealGroupName,
        groupsDealID: req.groupsDealID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async listNoteGroupDeal(req): Promise<any> {

    try {

      let reqObj = {
        mode: "list-note-groupdeal",
        buyerID: req?.buyerID,
        groupsDealID: req.groupsDealID,
        email: req?.email,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  // delete-note-groupdeal
  async deleteNoteGroupDeal(req): Promise<any> {

    try {

      let reqObj = {
        mode: "delete-note-groupdeal",
        groupsDealNoteID: req.groupsDealNoteID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            resolve(resp);
          },
          error: error => {
            resolve(error);
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async requestMoreInformationNote(req): Promise<any> {
    let reqObj = {
      mode: "update-request-information-group",
      dealsGroupID: req.dealsGroupID,
      status: req.status,
      description: req.description,
      sellerID: req.sellerID,
      buyerID: req.buyerID,
      whoSent: req.whoSent,
      typeDeal: req.typeDeal,
      connectionID: req.connectionID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getUnreadMessages(req): Promise<any>{
    let reqObj = {
      mode: "get-unread-messages",
      dealsGroupID: req.dealsGroupID,
      buyers: req.buyers,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false,
    }
    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async listMoreInformationNote(req): Promise<any> {
    let reqObj = {
      mode: "get-information-extra-group",
      dealsGroupID: req.dealsGroupID,
      sellerID: req.sellerID,
      buyerID: req.buyerID,
      typeDeal: req.typeDeal,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false,
      connectionID: req.connectionID,
      rol: req.rol
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async updateGetDealsGroup(req): Promise<any> {

    try {

      let reqObj = {
        mode: "update-get-deals-group",
        DealsGroupID: req.DealsGroupID,
        LeaseNo: req.LeaseNo,
        ObligorName: req.ObligorName,
        BusinessForm: req.BusinessForm,
        ObligorCity: req.ObligorCity,
        ObligorState: req.ObligorState,
        BookDate: req.BookDate,
        FirstPmtDate: req.FirstPmtDate,
        NextDueDate: req.NextDueDate,
        MaturityDate: req.MaturityDate,
        Term: req.Term,
        PymtsMade: req.PymtsMade,
        PymtsRem: req.PymtsRem,
        DaysPastDue: req.DaysPastDue,
        days31_60: req.days31_60,
        PaymentFrequency: req.PaymentFrequency,
        EquipCost: req.EquipCost,
        PurchaseOption: req.PurchaseOption,
        LeaseBooked: req.LeaseBooked,
        SecurityDep: req.SecurityDep,
        YearsBusiness: req.YearsBusiness,
        PayNetMasterScore: req.PayNetMasterScore,
        PmtType: req.PmtType,
        GeneralEquipDesc: req.GeneralEquipDesc,
        EquipSource: req.EquipSource,
        GrossReceivable: req.GrossReceivable,
        ObligorTaxID: req.ObligorTaxID,
        NaicsIndustry: req.NaicsIndustry,
        DateOpened: req.DateOpened,
        PymtAmtDue: req.PymtAmtDue,
        days61_90: req.days61_90,
        HighFICO: req.HighFICO,
        PrincipalBalance: req.PrincipalBalance,
        ObligorRegion: req.ObligorRegion,
        PayNetAPD: req.PayNetAPD,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  async uploadNotes(req): Promise<any> {

    try {
      let reqObj = {
        mode: "upload-notes",
        userTypeID: req.userTypeID,
        file: req.file,
        noteID: req.noteID,
        typeDeal: req.typeDeal,
        dealId: req.dealId,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  // revoke-access-deal-group
  async revokeAccessDealGroup(req): Promise<any> {

    try {
      let reqObj = {
        mode: "revoke-access-deal-group",
        dealsGroupID: req.dealsGroupID,
        buyerID: req.buyerID,
        sellerID: req.sellerID,
        notes: req.notes,
        submittedDate: req.submittedDate,
        declinedDate: req.declinedDate,
        reason: req.reason,
        groupsDealID: req.groupsDealID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getDealsGroupOffers(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-deals-group-offers",
        groupsDealID: req.groupsDealID,
        buyerID: req?.buyerID,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async deleteGroupDeal(req): Promise<any> {

    try {
      let reqObj = {
        mode: "delete-group-deal",
        groupsDealID: req.groupsDealID,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  // get-status-deal-group
  async getStatusDealGroup(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-status-deal-group",
        groupsDealID: req.groupsDealID,
        buyerID: req.buyerID,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  // create-status-deal-group
  async createStatusDealGroup(reqStatus): Promise<any> {

    try {

      reqStatus["logginAccessKey"] = this.authenticationService.currentUserValue.LoginSessionKey;
      reqStatus["emulate"] = this.subdomain == 'cp' ? true : false;
      reqStatus["userId"] = this.authenticationService.currentUserValue.UserDetails.UserID;
      reqStatus["mode"] = "create-status-deal-group";


      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqStatus,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  // update-title-group-deal
  async updateTitleGroupDeal(req): Promise<any> {

    try {
      let reqObj = {
        mode: "update-title-group-deal",
        groupsDealID: req.groupsDealID,
        nameGroup: req.nameGroup,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {
        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getPlansConnectifi(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-plans-connectifi",
        typeUser: req.typeUser,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getIndividualNotesManager(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-notes-deal-manager",
        entityID: req.entityID,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getPoolNotesManager(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-notes-pool-deal-manager",
        entityID: req.entityID,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async declineDealOffer(req): Promise<any> {

    try {
      let reqObj = {
        mode: "decline-offer-deal",
        statusID: req.statusID,
        reason: req?.reason,
        notes: req?.notes,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

    async declineRequestConnectifi(req): Promise<any> {
    try {
      let reqObj = {
        mode: "decline-connectifi-request",
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false,
        ...req
      }
      console.log(reqObj)
      return new Promise((resolve) => {
        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
    
  }

  async acceptRequestConnectifiBuyer(req): Promise<any> {

    try {
      let reqObj = {
        mode: "add-connection-connectifi",
        connectifiRequestID: req.connectifiRequestID,
        statusRequest: req.statusRequest,
        createdBy: req.createdBy,
        userID: req.userID,
        email: req.email,
        userRole: req.userRole,
        acceptedBy: req.acceptedBy,
        acceptDate: req.acceptDate,
        requestChannel: req.requestChannel,
        requestedBy: req.requestedBy,
        requestDate: req.requestDate,
        isPrivateSharedOnly: req.isPrivateSharedOnly,
        name: req.name,
        officePhone: req.officePhone,
        companyName: req.companyName,
        role: req.role,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }

      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  //Experimental => individual status vs individual Offers Leo Munoz
  async insertDealsOffer(req): Promise<any> {
    try {
      let reqObj = {
        mode: "offer-deal-ligth2024",
        StatusID: req?.StatusID,
        Status: req?.Status,
        ConnectionID: req?.ConnectionID,
        DealID: req?.DealID,
        Notes: req?.Notes,
        dealStatusData: req?.dealStatusData,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {
        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getPoolDealList(req): Promise<any> {
    try {
      let reqObj = {
        mode: "get-pool-deal-list",
        DealPoolID: req?.DealPoolID,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {
        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve({Data: result['message'], Message: "Success", ResponseCode: 200});
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }


  async addDealStatus(req): Promise<any> {
    try {
      let reqObj = {
        mode: "add-deal-status",
        ConnectionID: req?.ConnectionID,
        DealID: req?.DealID,
        Status: req?.Status,
        StatusID: req?.StatusID,
        CurrentDate: req?.CurrentDate,
        FundedBuyRate: req?.FundedBuyRate,
        FundingAmount: req?.FundingAmount,
        FeeIncome: req?.FeeIncome,
        Notes: req?.Notes,
        userId: this.authenticationService.currentUserValue.UserDetails.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {
        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };
        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

    async getRequestLogs(req): Promise<any> {
    let reqObj = {
      mode: "get-connectifi-log",
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false,
      ...req
    }


    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


    async saveLogout(): Promise<any> {
    let reqObj = {
      mode: "save-logout",
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false,
    }

    console.log("reqLogout", reqObj)


    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getDealProfile(sellerID?): Promise<any> {
    let reqObj = {
      mode: "get-deal-profile",
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false,
      sellerID: sellerID
    }

    console.log(reqObj)

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async updateDealProfile(req): Promise<any> {
    let reqObj = {
      mode: "update-deal-profile",
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false,
      ...req
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              console.log(result)
              
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
      
    }
  }

  async saveDealProfile(req): Promise<any> {
    let reqObj = {
      mode: "save-deal-profile",
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false,
      ...req
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getSellersConnectifiDealProfile(): Promise<any> {

    let reqObj = {
      mode: "get-sellers-connectifi-deal-profile",
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        let tempHeaders = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'kintoken': localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          tempHeaders)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  // block-user-connectifi
  async blockUserConnectifi(req): Promise<any> {
    let reqObj = {
      mode: "block-user-connectifi",
      sellerID: req.sellerID,
      buyerID: req.buyerID,
      requestedBy: req.requestedBy,
      connectifiRequestID: req.connectifiRequestID,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }


    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async unblockUserConnectifi(req): Promise<any> {
    let reqObj = {
      mode: "unblock-user-connectifi",
      connectifiBlockID: req.connectifiBlockID,
      requestedBy: req.requestedBy,
      connectifiRequestID: req.connectifiRequestID, 
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async notifyAccessConnectifiDomain(req): Promise<any> {
    let reqObj = {
      mode: "notify-access-connectifi-domain",
      domain: req.domain,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async sendMultipleGenericEmail(req): Promise<any> {
    let reqObj = {
      mode: "send-multiple-generic-email",
      emails: req.emails,
      genericText: req.genericText,
      subject: req.subject,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async sendNotificationsSeller(req): Promise<any> {
    let reqObj = {
      mode: "notification-seller-email",
      typeDeal: req.typeDeal,
      idDeal: req.idDeal,
      genericText: req.genericText,
      subject: req.subject,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async addDoccufi(req): Promise<any> {
    let reqObj = {
      mode: "add-doccufi",
      name: req.name,
      description: req.description,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async updateDocufi(req): Promise<any> {
    let reqObj = {
      mode: "update-docufi",
      docufiId: req.doccufiId,
      name: req.name,
      description: req.description,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async deleteDocufi(req): Promise<any> {
    let reqObj = {
      mode: "delete-docufi",
      docufiId: req.doccufiId,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getDoccufi(req): Promise<any> {
    let reqObj = {
      mode: "get-doccufi",
      isBuyer: req.isBuyer,
      isManager: req.isManager,
      userEmail: req.userEmail,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem("docManagerToken"),
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async addInviteDoccufi(req): Promise<any> {

    try {
      let reqObj = {
        mode: "add-invite-doccufi",
        doccufiId: req.groupDealId,
        buyerId: req?.buyerId,
        userId: req.userId,
        emailBuyer: req.emailBuyer,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async listAllInviteDoccufi(req): Promise<any> {

    try {
      let reqObj = {
        mode: "list-all-invite-doccufi",
        doccufiId: req.doccufiId,
        userId: req.userId,
        userEmail: req.userEmail,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async listPrimaryInviteDoccufi(req): Promise<any> {

    try {
      let reqObj = {
        mode: "list-primary-invite-docufi",
        doccufiId: req.doccufiId,
        userId: req.userId,
        userEmail: req.userEmail,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getChatViewDocufiForBuyer(req){
    try {
      let reqObj = {
        mode: "get-doccufi-buyer-chatview",
        buyerEmail: req.Email,
        userId: req.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  
  }
  async getChatViewDocufiForSeller(req){
    try {
      let reqObj = {
        mode: "get-doccufi-seller-chatview",
        sellerEmail: req.Email,
        userId: req.UserID,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  
  }


  async deleteInviteDocufi(req): Promise<any> {

    try {
      let reqObj = {
        mode: "delete-invite-docufi",
        docufiId: req.docufiId,
        buyerId: req.buyerId,
        userId: req.userId,
        emailBuyer: req.emailBuyer,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getDocufiActivityLogs(req): Promise<any> {

    try {
      let reqObj = {
        mode: "get-docufi-activity-logs",
        docufiId: req.docufiId,
        userId: req.userId,
        isSeller: req.isSeller,
        logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
        emulate: this.subdomain == 'cp' ? true : false
      }
      return new Promise((resolve) => {

        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken'),
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers).subscribe({
          next: (resp: any) => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(resp['message']));
            } else {
              result = resp;
            }
            resolve(result['message']);
          },
          error: error => {
            let result;
            if (this.encryptData) {
              result = JSON.parse(decrypt(error['message']));
            } else {
              result = error;
            }
            resolve({ error: true, statusCode: result['statusCode'] });
          }
        });
      })
    } catch (error) {
      console.error(error);
    }
  }

  async getDocufiAssociateBuyers(req): Promise<any> {
    let reqObj = {
      mode: "get-docufi-associate-buyers",
      docufiId: req.dealGroupId,
      primaryBuyer: req.primaryBuyer,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }

  }


  async getCompanyFeatures(req): Promise<any> {
    let reqObj = {
      mode: "get-company-features",
      userEmail: req.userEmail,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }

  }


  async getDocufiPlans({typeUser}): Promise<any> {
    let reqObj = {
      mode: "get-plans-docufi",
      typeUser: typeUser,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }
  async getContractedSellerCompanies({typeUser}): Promise<any> {
    let reqObj = {
      mode: "get-contracted-sellers-companies",
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }


  async importFiles(req): Promise<any> {
    let reqObj = {
      mode: "move-files-s3",
      folderId: req.folderId,
      entityId: req.entityId,
      entityType: req.entityType,
      importPath: req.importPath,
      fromEntityType: req.fromEntityType,
      fromEntityId: req.fromEntityId,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    }

    try {
      return new Promise((resolve) => {

        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager,
          reqObj,
          headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }
  async getDealBuyersInvitedByBuyers(req): Promise<any> {
    const reqObj = {
      mode: "get-deal-buyers-invited-by-buyers",
      dealId: req.dealId,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    };

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async getDealCompanyInvitedBuyers(req): Promise<any> {
    const reqObj = {
      mode: "get-deal-company-invited-buyers",
      dealId: req.dealId,
      emailDomain: req.emailDomain,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    };

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async getBuyersByDomain(req): Promise<any> {
    const reqObj = {
      mode: "get-buyers-by-domain",
      companyDomain: req.domain,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    };

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async getDealGroupCompanyInvitedBuyers(req): Promise<any> {
    const reqObj = {
      mode: "get-deal-group-company-invited-buyers",
      dealGroupId: req.groupDealId,
      emailDomain: req.emailDomain,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    };

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async getDealGroupBuyersInvitedByBuyers(req): Promise<any> {
    const reqObj = {
      mode: "get-deal-group-buyers-invited-by-buyers",
      dealGroupId: req.groupDealId,
      emailDomain: req.emailDomain,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    };

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async getDealPoolCompanyInvitedBuyers(req): Promise<any> {
    const reqObj = {
      mode: "get-deal-pool-company-invited-buyers",
      dealPoolId: req.dealPoolId,
      emailDomain: req.emailDomain,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    };

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async getDealPoolBuyersInvitedByBuyers(req): Promise<any> {
    const reqObj = {
      mode: "get-deal-pool-buyers-invited-by-buyers",
      dealPoolId: req.dealPoolId,
      emailDomain: req.emailDomain,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    };

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async getBuyerDealHistory(req): Promise<any> {
    const reqObj = {
      mode: "get-buyer-deal-history",
      buyerEmail: req.buyerEmail,
      sellerDomain: req.sellerDomain,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      userId: this.authenticationService.currentUserValue.UserDetails.UserID,
      emulate: this.subdomain == 'cp' ? true : false
    };

    try {
      return new Promise((resolve) => {
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http.post(this.urlDocManager, reqObj, headers)
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }


}
